import { onlyDigits } from "./phone/onlyDigits"

const WHATSAPP_TEXT = "Olá! Gostaria de informações sobre o evento."

type TSellerInfo = {
  corporateFantasyName?: string | null
  corporateName?: string | null
} | null

export type TSupportContact = {
  label: string
  href: string
  /** Abre em outra aba (WhatsApp); ligação (tel:) abre no próprio app. */
  external: boolean
}

/**
 * Quem responde pela loja: nome fantasia, senão razão social (os mesmos
 * campos do rodapé). `name` não serve: no store ele vira o nome do evento.
 */
export const sellerName = (info?: TSellerInfo): string =>
  String(info?.corporateFantasyName || info?.corporateName || "").trim()

/**
 * Telefone de contato do cliente: celular abre o WhatsApp com uma mensagem
 * pronta; fixo vira ligação. Número inválido ou ausente → null.
 */
export const sellerContact = (
  phone?: string | null,
): TSupportContact | null => {
  let d = onlyDigits(String(phone ?? ""))
  if ((d.length === 12 || d.length === 13) && d.startsWith("55")) d = d.slice(2)

  if (d.length === 11 && d[2] === "9") {
    return {
      label: `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`,
      href: `https://wa.me/55${d}?text=${encodeURIComponent(WHATSAPP_TEXT)}`,
      external: true,
    }
  }

  if (d.length === 10) {
    return {
      label: `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`,
      href: `tel:+55${d}`,
      external: false,
    }
  }

  return null
}
